import React from "react";

const UnderConstruction = () => {
  return (
    <div className="flex items-center gap-y-[20px] justify-center flex-col w-full h-full">
      <img src="/svgs/undraw_under_construction_-46-pa (1).svg" />
      <div className="text-[20px] text-center">Under Construction</div>
    </div>
  );
};

export default UnderConstruction;
